import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { ApproachingNDaysSinceEntryDateDto, ApproachingNDaysSinceEntryDateQueryParams } from 'dtos/toDoLists/conformity'
import { URIQuery } from 'utils'

const baseUrl = (): string => '/api/to-do-lists/conformity/approaching-120-days-since-entry-date'

export const getToDoList = (queryParams: ApproachingNDaysSinceEntryDateQueryParams, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<ApproachingNDaysSinceEntryDateDto[]>>(baseUrl() + URIQuery(queryParams), { cancelToken }).then(res => res.data)
